<div class="bg-white account-settings">
    <h3 class="settings-header px-4 py-3 mb-4">
        <i class="far fa-user"></i> {{'account_settings' | translate}} -
        <small>{{'account_settings_desc' | translate}}</small>
    </h3>
    
    @if(teamMember){
    <div class="px-4 pb-5">
        <div class="dash-tiles row-fluid pb-3 pb-md-0">
            <div class="dash-tile dash-tile-excellent clearfix col-md-3">
                <div class="dash-tile-header">{{'creation_date' | translate}}</div>
                <div class="dash-tile-icon">
                    <i class="far fa-birthday-cake"></i>
                </div>
                <div class="dash-tile-text">
                    <small>{{ teamMember.created | date }}</small>
                </div>
            </div>
            <div class="dash-tile dash-tile-good clearfix col-md-3">
                <div class="dash-tile-header">{{'number_of_teams' | translate}}</div>
                <div class="dash-tile-icon">
                    <i class="far fa-users"></i>
                </div>
                <div class="dash-tile-text">
                    {{teamMember.teams.length}}
                </div>
            </div>
            <div class="dash-tile dash-tile-average clearfix col-md-3">
                <div class="dash-tile-header">{{'number_of_moods' | translate}}</div>
                <div class="dash-tile-icon">
                    <i class="far fa-smile"></i>
                </div>
                <div class="dash-tile-text">
                    {{teamMember.moodsCount}}
                </div>
            </div>
            <div class="dash-tile dash-tile-hard clearfix col-md-3" [hidden]="!teamMember.lastMood">
                <div class="dash-tile-header">{{'last_mood_date' | translate}}</div>
                <div class="dash-tile-icon">
                    <i class="far fa-history"></i>
                </div>
                <div class="dash-tile-text">
                    <small>{{ teamMember.lastMood | date }}</small>
                </div>
            </div>
        </div>
    
        <form [formGroup]="form">
            <div class="form-horizontal form-box">
                <h4 class="form-box-header">{{'profile' | translate}}</h4>
                <div class="form-group px-5 required" [ngClass]="{'has-error' : $safeNavigationMigration(errors?.firstName)}">
                    <label class="control-label" for="firstName">{{'firstname' | translate}}</label>
                    <div class="col-md-10 col-lg-4">
                        <input type="text" id="firstName" name="firstName" class="form-control" 
                               formControlName="firstName">
                               
                        @if((firstName.invalid && (firstName.dirty || firstName.touched))){
                            <span class="text-danger">{{'error.required' | translate}}</span>
                        }
                        @if((firstName?.errors?.minlength)){
                            <span class="text-danger"> ({{'error.minLengthTwo' | translate }})</span>
                        }
                    </div>
                </div>
                <div class="form-group px-5" [ngClass]="{'has-error' : $safeNavigationMigration(errors?.lastName)}">
                    <label class="control-label" for="lastName">{{'lastname' | translate}}</label>
                    <div class="col-md-10 col-lg-4">
                        <input type="text" id="lastName" name="lastName" class="form-control" 
                               formControlName="lastName">
                        @if((lastName.invalid && (lastName.dirty || lastName.touched))){
                            <span class="text-danger">{{'error.required' | translate}}</span>
                        }
                        @if((lastName?.errors?.minlength)){
                            <span class="text-danger"> ({{'error.minLengthTwo' | translate }})</span>
                        }
                    </div>
                </div>
                <div class="form-group px-5" [ngClass]="{'has-error' : $safeNavigationMigration(errors?.language)}">
                    <label class="control-label" for="language">{{'language' | translate}}</label>
                    <div class="col-md-10 col-lg-4">
                        <tm-language-select formControlName="language"></tm-language-select>
                        @if(errors?.language){
                            <span class="text-danger ps-2">{{errors.language}}</span>
                        }
                    </div>
                </div>
            </div>
            <div class="form-horizontal form-box" formGroupName="notificationTime">
                <h4 class="form-box-header">{{'notificationTime' | translate}}</h4>
                <div class="form-group px-5" [ngClass]="{'has-error' : $safeNavigationMigration(errors?.notificationTime?.timeZone)}">
                    <label class="control-label" for="timeZone">{{'timeZone' | translate}}</label>
                    <div class="col-md-10 col-lg-4">
                        <tm-timezone-picker formControlName="timeZone"></tm-timezone-picker>
                        @if(errors?.notificationTime?.timeZone){
                            <span class="text-danger">{{errors.notificationTime.timeZone}}</span>
                        }
                    </div>
                </div>
                <div class="form-group px-5" [ngClass]="{'has-error' : $safeNavigationMigration(errors?.notificationTime?.time)}">
                    <label class="control-label" for="preferedTimeForEmails">{{'preferedTimeForEmails' | translate}}</label>
                    <div class="col-md-10 col-lg-4">
                        <tm-timepicker formControlName="time"></tm-timepicker>
                        @if(errors?.notificationTime?.time){
                            <span class="text-danger">{{errors.notificationTime.time| translate}}</span>
                        }
                    </div>
                </div>
            </div>

            <div class="form-horizontal form-box">
                <h4 class="form-box-header">{{'myaccount.other_notifications' | translate}}</h4>
                <div class="form-group px-5">
                    <p>Be notified on:</p>
                    @for(subscription of notificationTypes; track subscription.id){
                        <div class="row ps-5 g-0 align-items-center">
                            <div class="col-auto">
                                <!--                            <tm-slide-toggle formControlName="emailEnabled"-->
                                <!--                                             (ngModelChange)="toggle_channel('email-notification')">-->
                                <!--                            </tm-slide-toggle>-->
                                <tm-slide-toggle [ngModel]="subscription.active"
                                        (ngModelChange)="toggle_notification(subscription)"
                                                 [ngModelOptions]="{standalone: true}">
                                </tm-slide-toggle>
                            </div>
                            <div class="col-auto ps-2">
                                <label class="col-form-label">{{ subscription.label }}</label>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <div class="form-horizontal form-box">
                <h4 class="form-box-header">{{'outOfOffice' | translate}}</h4>
                <div class="form-group px-5">
                    <tm-out-of-office formControlName="outOfOffice"></tm-out-of-office>
                </div>
            </div>
    
            @if(teamMember.hasPassword != null){
                <div class="form-horizontal form-box">
                    <h4 class="form-box-header">{{'password' | translate}}</h4>
                    @if(!teamMember.hasPassword) {
                        <div class="form-group px-5">
                            <div></div>
                            <div class="col-md-10 text-warning">{{'no_password' | translate}}</div>
                        </div>
                    }
                    
                    <div class="form-group px-5">
                        <div></div>
                        <div class="col-md-10">
                            @if(!passwordRest){
                                <button type="button" class="btn btn-primary" data-cy="passwordButton"  
                                        (click)="resetPassword()"> <i class="glyphicon glyphicon-lock"></i>
                                    @if(teamMember.hasPassword) {
                                        <span>{{'update_password' | translate}}</span>
                                    }@else{
                                        <span>{{'create_password' | translate}}</span>
                                    } 
                                </button>
                            }
                            @if(passwordRest){
                                <div class="alert alert-success" data-cy="passwordSuccess">
                                    {{'check_your_email' | translate : {email: teamMember.email.value} }}
                                </div>
                            }  
                        </div>
                    </div>
                </div>
            }
            
            <notification-days-settings (onTeamChange)="onTeamChange($event)"></notification-days-settings>
            
        </form>
    </div>
    }
</div>